import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";

import Pagination from "../deprecated_dependencies/rbs_pagination/Pagination";

import ModalWrapper from "./ModalWrapper";

import AccountingHelper from "../utils/AccountingHelper";
import Api from "../utils/Api";
import DateHelper from "../utils/DateHelper";

export default class BudgetAudit extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = { budgetAudit: [] };
		this.handleClose = this.handleClose.bind(this);
		this.handleSelectPage = this.handleSelectPage.bind(this);
	}

	handleClose()
	{
		this.props.onClose();
	}

	async handleSelectPage(selectedPage)
	{
		try
		{
			const budgetAuditPaged = await Api.getBudgetAuditInformation(this.props.category.id, this.props.currencyId, selectedPage);
			this.setState({
				budgetAudit: budgetAuditPaged.results,
				paging: budgetAuditPaged.paging
			});
		}
		catch (message)
		{
			// TODO: BA-152 handle error
			console.error(message);
		}
	}

	componentDidMount()
	{
		// Select the first page
		this.handleSelectPage();
	}

	render()
	{
		const { budgetAudit, paging } = this.state;
		const hasManyPages = paging && paging.totalPages > 10;

		const footerElements = [
			<div key="footer">
				<Button key={0} onClick={this.handleClose}>Close</Button>
			</div>
		];

		return (
			<ModalWrapper
				title={`Budget History Details: ${this.props.category.name}`}
				modalClassName={"budget-audit-modal"}
				footerElements={footerElements}
			>
				<div>
					<div key="audit-listing">
						{budgetAudit.map(auditRecord => {
							const dateString = DateHelper.formatDate(auditRecord.date);

							return (
								<div key={`audit${auditRecord.id}`} className={"form-group row"}>
									<div className="col-xs-3">
										{dateString}
									</div>
									<div className="col-xs-6">
										{auditRecord.note}
									</div>
									<div className="col-xs-3">
										{AccountingHelper.formatMoney(auditRecord.amount, this.props.currencyId)}
									</div>
								</div>
							);
						})}
					</div>
					{paging && paging.totalPages > 1 &&
						<div id="paging" key="paging">
							<Pagination
								prev
								next
								items={paging.totalPages}
								activePage={paging.pageIndex}
								onSelect={this.handleSelectPage}
								first={hasManyPages}
								last={hasManyPages}
								ellipsis={hasManyPages}
								boundaryLinks={hasManyPages}
								maxButtons={hasManyPages ? 5 : null}
							/>
						</div>
					}
				</div>
			</ModalWrapper>
		);
	}
}

BudgetAudit.propTypes = {
	onClose: PropTypes.func,
	category: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	currencyId: PropTypes.number
};



// WEBPACK FOOTER //
// ./Components/components/BudgetAudit.jsx